module.exports = __webpack_public_path__ + "static/media/logo1.c8fea83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo1.png
// module id = 463
// module chunks = 2